"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcessInstanceState = void 0;
/**
 * Lists the various states that a ProcessInstance can be in.
 */
var ProcessInstanceState;
(function (ProcessInstanceState) {
    ProcessInstanceState["running"] = "running";
    ProcessInstanceState["finished"] = "finished";
    ProcessInstanceState["error"] = "error";
    ProcessInstanceState["terminated"] = "terminated";
})(ProcessInstanceState = exports.ProcessInstanceState || (exports.ProcessInstanceState = {}));
//# sourceMappingURL=ProcessInstance.js.map